import './Main.scss'
import { LeftSidebar } from '../left-sidebar/LeftSidebar';
import { RightSidebar } from '../right-sidebar/RightSidebar';
import { Center } from '../center/Center';
import { useEffect } from 'react';
import { FairnessModal } from '../fairness-modal/FairnessModal';
import { ReBetModal } from '../re-bet-modal/ReBetModal';
import { ReconnectingModal } from '../reconnect-modal/ReconnectModal';
import { ConnectionLostModal } from '../connection-lost-modal/ConnectionLostModal';
import { ToastNotifications } from '../toast-notifications/ToastNotifications';
import { observer } from 'mobx-react';
import { gameStore } from '../../platform/stores';
import { RulesModal } from '../rules-modal/RulesModal';
import { PayTableModal } from '../pay-table-modal/PayTableModal';
import { RotatePhone } from '../rotate-phone/RotatePhone';
import { WinPopup } from '../win-popup/WinPopup';
import { Keypad } from '../keypad/Keypad';
import { Sidebar } from '../sidebar/Sidebar';

export const Main = observer(() => {
  const { gameInitialized } = gameStore;

  useEffect(() => {
    setTitle();
    gameStore.setPropertiesFromQueryString();
  });

  const setTitle = () => {
    document.title = 'Keno';
  }

  return (
    <div className="main-component">
      {
        gameInitialized
          ?
          <>
            <div className="left mobile-hidden">
              <LeftSidebar/>
            </div>
            <div className="center">
              <Center/>
            </div>
            <div className="right mobile-hidden">
              <RightSidebar/>
            </div>

            <Keypad/>
            <Sidebar/>
            <WinPopup/>
            <ReBetModal/>
            <RulesModal/>
            <RotatePhone/>
            <PayTableModal/>
            <FairnessModal/>
            <ReconnectingModal/>
            <ConnectionLostModal/>
            <ToastNotifications/>
          </>
          :
          <></>
      }
    </div>
  );
});
